export default {
  token: '',
  activeUser: '',
  userID: '',
  notifSetting: {
    drumPicking: true,
    jobOrder: true,
  }
}